import { Directive } from '@angular/core';
import { IfLoggedInDirectiveDef } from '@df/session/customer/if-logged-in.directive.def';

/**
 * Use this directive to present element only in user is logged in
 *
 * ```html
 * <div *ifLoggedIn>...</div>
 * ```
 */
@Directive({
    selector: '[ifLoggedIn]',
    standalone: true
})
export class IfLoggedInDirective extends IfLoggedInDirectiveDef {}
